import axios from 'axios'

const state = {
    promocode: {},
    promocodes: {},
    promocode_errors: {},
    promocode_loading: false,
}

const getters = {
    promocode: state => state.promocode,
    promocodes: state => state.promocodes,
    promocode_errors: state => state.promocode_errors,
    promocode_loading: state => state.promocode_loading,
}

const mutations = {
    setPromocode(state, promocode) {
        state.promocode = promocode
    },
    setPromocodes(state, promocodes) {
        state.promocodes = promocodes
    },
    setPromocodeErrors(state, promocode_errors) {
        state.promocode_errors = promocode_errors
    },
    setPromocodeLoading(state, promocode_loading) {
        state.promocode_loading = promocode_loading
    },
}

const actions = {
    async storePromocode({commit}, data) {
        commit('setPromocodeLoading', true)
        commit('setPromocodeErrors', {})
        try {
            let response = await axios.post(`/api/admin/promocodes/store`, data)
            commit('setPromocodeLoading', false)
            commit('setPromocodeErrors', {})
            return response.data.ok
        } catch (error) {
            console.log(error);
            commit('setPromocodeLoading', false)
            commit('setPromocodeErrors', error.response.data.errors)
            return false
        }
    },
    async getPromocodes({commit}, data) {
        try {
            let response = await axios.get(`/api/admin/promocodes`, data)
            commit('setPromocodes', response.data)
            return response.data.ok
        } catch (error) {
            console.log(error);
                return false
        }
    },

    async getPromocode({commit}, id) {
        try {
            let response = await axios.get(`/api/admin/promocodes/${id}/show`)
            commit('setPromocode', response.data?.data)
            return response.data.ok
        } catch (error) {
            console.log(error);
            return false
        }
    },
    async updatePromocode({commit}, data) {
        commit('setPromocodeLoading', true)
        commit('setPromocodeErrors', {})
        try {
            let response = await axios.put(`/api/admin/promocodes/${data.id}/update`, data)
            commit('setPromocodeLoading', false)
            commit('setPromocodeErrors', {})
            return response.data
        } catch (error) {
            console.log(error);
            commit('setPromocodeLoading', false)
            commit('setPromocodeErrors', error.response.data.errors)
            return false
        }
    },
}

export default {
    state,
    getters,
    mutations,
    actions
}